<div class="map-overlay">
  <google-map *ngIf="mapLoaded$ | async" [options]="mapOptions" (fullscreenchange)="onFullScreenChange()">
    <map-marker [options]="markerOptions"></map-marker>
  </google-map>

  <div class="location-information" [class.fullscreen]="isFullScreen" #locationInformation>

    <div class="espg-code">
      <div class="content">
        <div class="column">
          <h6 class="title">{{ 'configurations-fields.CoordinateSystem' | translate }}</h6>
          <p class="value">{{ data.espg ? data.espg : '-' }}</p>
        </div>
      </div>
    </div>

    <div class="coordinates">
      <div class="content">
        <div class="column">
          <h6 class="title">{{ 'configurations-fields.Latitude' | translate }}</h6>
          <p class="value">{{data.location.Latitude | limit: 6}}</p>
        </div>
        <div class="column">
          <h6 class="title">{{ 'configurations-fields.Longitude' | translate }}</h6>
          <p class="value">{{data.location.Longitude | limit: 6}}</p>
        </div>
        <div class="column">
          <h6 class="title">{{ 'configurations-fields.Altitude' | translate }}</h6>
          <p class="value">{{data.location.Altitude | limit: 6}}</p>
        </div>
      </div>
    </div>

  </div>
</div>
